"use strict";

var _defineProperty = require("/home/runner/work/moderneyegallery/moderneyegallery/node_modules/@babel/runtime/helpers/defineProperty.js");

var _taggedTemplateLiteral = require("/home/runner/work/moderneyegallery/moderneyegallery/node_modules/@babel/runtime/helpers/taggedTemplateLiteral.js");

var _templateObject, _templateObject2, _templateObject3;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var styled_1 = __importDefault(require("@emotion/styled"));

var react_1 = __importStar(require("react"));

var index_1 = require("../../../index");

var CustomActionSC = styled_1.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral([""])));
var FieldMessageSC = styled_1.default.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral([""])));
var FieldTemplateSC = styled_1.default.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral([""])));

var FieldTemplate = function FieldTemplate(_ref) {
  var children = _ref.children,
      customAction = _ref.customAction,
      customActionProps = _ref.customActionProps,
      templateProps = _ref.templateProps,
      message = _ref.message,
      _ref$meta = _ref.meta,
      error = _ref$meta.error,
      touched = _ref$meta.touched,
      warning = _ref$meta.warning;

  var _ref2 = (0, react_1.useContext)(index_1.FormidableContext),
      t = _ref2.t,
      sc = _ref2.sc;

  return react_1.default.createElement(react_1.default.Fragment, null, react_1.default.createElement(FieldTemplateSC, _objectSpread({
    as: sc && sc.fieldTemplate
  }, templateProps), children, customAction && react_1.default.createElement(CustomActionSC, _objectSpread({
    as: sc && sc.customTop
  }, customActionProps), customAction)), touched && (error && react_1.default.createElement(FieldMessageSC, {
    as: sc && sc.fieldMessage,
    color: "error"
  }, t ? t(error) : error) || warning && react_1.default.createElement(FieldMessageSC, {
    as: sc && sc.fieldMessage,
    color: "warning"
  }, t ? t(warning) : warning)), message && react_1.default.createElement(FieldMessageSC, {
    as: sc && sc.fieldMessage
  }, t ? t(message) : message));
};

exports.default = FieldTemplate;